import { prefetchPage } from 'pricing-pages-ui/routes/loadablePages';
import { PublicContentHubPage } from '../pages/loadablePages';
import { getPageSlug } from '../utils/getPageSlug';

/**
 * This is a map of public page slugs to their loadable components.
 * Rigth now this is manually maintained because we are launching only one page at a time.
 */
const PUBLIC_PAGE_PREFETCH = {
  content: PublicContentHubPage
};
export function prefetchCurrentRouteChunk() {
  const slug = getPageSlug();
  if (!slug) return;
  const publicPage = PUBLIC_PAGE_PREFETCH[slug];
  if (publicPage) {
    void publicPage.preload();
  }
  prefetchPage(slug);
}